angular.module('components.media.FileService', [
  'global'
])

/**
 * The FileService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class FileService
 * @constructor
 * @module components.media.FileService
 */
.factory('FileService', [
  function () {
    'use strict';

    return {};
  }
]);
